import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/grin-beam': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM248 456C137.7 456 48 366.3 48 256S137.7 56 248 56 448 145.7 448 256 358.3 456 248 456zM353.6 304.6C327.7 312.9 289.2 317.7 248 317.7S168.4 312.9 142.4 304.6C132.6 301.5 123 309.9 124.7 319.9 132.6 367 196 399.9 248 399.9S363.3 367 371.3 319.9C372.9 310.1 363.6 301.5 353.6 304.6zM117.7 231.7C121.2 232.8 125.1 231.2 127 228L136.5 211C144.2 197.3 155.7 189.4 168 189.4S191.8 197.3 199.5 211L209 228C211.1 231.7 215.2 232.7 218.3 231.7 221.9 230.6 224.3 227.2 224 223.4 220.7 181.3 191.8 152 168 152S115.3 181.3 112 223.4C111.7 227.1 114.1 230.6 117.7 231.7zM277.7 231.7C281.2 232.8 285.1 231.2 287 228L296.5 211C304.2 197.3 315.7 189.4 328 189.4S351.8 197.3 359.5 211L369 228C371.1 231.7 375.2 232.7 378.3 231.7 381.9 230.6 384.3 227.2 384 223.4 380.7 181.3 351.8 152 328 152S275.3 181.3 272 223.4C271.7 227.1 274.1 230.6 277.7 231.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/grin-beam.js
// module id = QG4u
// module chunks = 144